module.exports = __webpack_public_path__ + "media/images/payment/visa-electron-04c658ca8308415c8edbc8a9f80453d9.png";